import { render, staticRenderFns } from "./VaultSetupMethod.vue?vue&type=template&id=b84def4c&scoped=true"
import script from "./VaultSetupMethod.vue?vue&type=script&lang=js"
export * from "./VaultSetupMethod.vue?vue&type=script&lang=js"
import style0 from "./VaultSetupMethod.vue?vue&type=style&index=0&id=b84def4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84def4c",
  null
  
)

export default component.exports